<template>
  <div class="padding width-100 min-height bg-image" style="background-color: #f6f6f6">
    <div style="height: 80px" class="margin-bs flex-column align-items-star justify-content-center margin-t">
      <div class="flex-row align-items-center justify-content-start width-100">
        <div
          class="margin-r bg-date flex-column align-items-center justify-content-around"
          style="height: 2.5rem; width: 2.5rem"
          @click="show = true"
        >
          <div style="height: 1rem" class="flex-row align-items-center justify-content-center">
            <div class="white fm-sh-regular width-100 fs-sml">{{ year }}</div>
          </div>
          <div class="flex-row align-items-end justify-content-center" style="height: 1.5rem">
            <div class="white fm-sh-bold fs-20 fw-mid line-height" style="color: #1e67f7">{{ month2 }}</div>
            <div class="white fm-sh-regular fs-sml" style="color: #1e67f7; line-height: 1rem">月</div>
          </div>
        </div>
        <van-image :src="require('../assets/image/leaderboard/title.png')" width="40%" height="2.1rem" fit="contain" />
      </div>
    </div>
    <div class="flex-column align-items-center justify-content-start width-100 bg-white br-reg" style="padding: 5%">
      <div
        v-if="!(dept_info instanceof Array) && $store.state.userInfo.dept_id != 0"
        class="flex-row align-items-center justify-content-start width-100 bg-title margin-bs padding-lr"
      >
        <div class="flex-column align-items-star justify-content-center width-100 height-100">
          <div class="white fs-mid-sml margin-bss fm-sh-bold">{{ dept_info.name }}</div>
          <div class="fs-mid-sml white fm-sh-regular flex-row align-items-center justify-content-center">
            传播值：{{ active == 1 ? (dept_info.score * 1).toFixed(2) : (dept_info.score * 1).toFixed(2) }}
            <span
              v-if="active == 2"
              style="display: inline-block"
              class="margin-ls"
              @click="$router.push({ path: '/personalDetails', query: { month: month } })"
              >查看明细</span
            >
            <div
              v-else-if="active == 0"
              class="flex-row align-items-center justify-content-center br-rol bg-white margin-ls"
              @click="$router.push({ path: '/departmentCompletion', query: { month: month, name: dept_info.name } })"
            >
              <van-icon name="arrow" color="#1e67f7" />
            </div>
          </div>
        </div>
        <div class="bg-ranking">
          <div class="fm-sc-heavy" style="font-size: 12px; transform: scale(0.9); color: #1e67f7">排名</div>
          <div class="fs-big fm-sh-bold" style="color: #1e67f7">{{ dept_info.ranking_num }}</div>
        </div>
      </div>
      <div
        v-if="$store.state.userInfo.dept_id != 0"
        class="flex-row width-100 align-items-center justify-content-center br-big"
        style="background: #e1f0ff"
      >
        <div
          :class="['width-33 textAlign-c fm-z', active == 0 ? 'active-tag' : 'normal-tag']"
          @click="
            () => {
              active = 0;
              getList();
            }
          "
        >
          部门
        </div>
        <div
          :class="['width-33 textAlign-c fm-z', active == 1 ? 'active-tag' : 'normal-tag']"
          @click="
            () => {
              active = 1;
              getList();
            }
          "
        >
          镇街
        </div>
        <div
          :class="['width-33 textAlign-c fm-z', active == 2 ? 'active-tag' : 'normal-tag']"
          @click="
            () => {
              active = 2;
              getList();
            }
          "
        >
          个人
        </div>
      </div>
      <!-- <div class="grey fs-sml fm-x margin-ts">排行榜数据每30秒更新一次</div> -->
      <div class="width-100 flex-column align-items-center justify-content-start margin-ts">
        <div class="flex-row width-100 align-items-center justify-content-spaceBetween br-big">
          <div class="textAlign-l fm-sh-bold fs-sml canNotWrap" style="width: 1.5rem">排名</div>
          <div class="width-39 textAlign-c fm-sh-bold fs-sml canNotWrap">{{ active == 2 ? '个人名称' : '部门名称' }}</div>
          <!-- <div class="width-30 textAlign-r fm-sh-bold fs-sml canNotWrap">{{ active == 2 ? '传播值' : '完成率' }}</div> -->
          <div @click="showRule" class="width-30 textAlign-r fm-sh-bold fs-sml canNotWrap">贡献值<van-icon name="question-o" /></div>
        </div>
        <van-list v-model="loading" :finished="finished" :finished-text="list.length == 0 ? '' : '没有更多了'" @load="onLoad" class="width-100">
          <div
            v-for="(item, key) in list"
            :key="key"
            class="flex-row width-100 align-items-center justify-content-spaceBetween padding-Tb-20"
            style="border-bottom: 1px dashed #979797"
          >
            <div class="textAlign-c fm-sh-regular" v-if="key > 2" style="width: 1.5rem">{{ key + 1 }}</div>
            <div v-else class="flex-row align-items-center justify-content-start">
              <van-image
                :src="
                  key == 0
                    ? require('../assets/image/leaderboard/no1.png')
                    : key == 1
                    ? require('../assets/image/leaderboard/no2.png')
                    : require('../assets/image/leaderboard/no3.png')
                "
                width="1.5rem"
                height="1rem"
              />
            </div>
            <div class="width-39 textAlign-c fm-sh-regular fs-sml canNotWrap show-line-1">
              {{ item.name || item.member_nickname }}
            </div>
            <div class="width-30 textAlign-r fm-sh-regular fs-sml" style="padding-right: 5px">
              {{ item.score == '0.0000' ? 0 : (item.score * 1).toFixed(2) }}
              <!-- {{ active == 2 ? item.score * 1 : (item.score * 1).toFixed(2) + '%' }} -->
            </div>
          </div>
          <van-empty
            v-if="list.length == 0"
            class="custom-image"
            :image="require('../assets/image/prizeManagement/empty-image.png')"
            description="暂无数据"
          />
        </van-list>
      </div>
    </div>
    <div style="margin-bottom: 80px"></div>
    <van-overlay :show="showGuiZe" class="flex-column align-items-center justify-content-center">
      <div class="width-80 br-reg overflow-h bg-white flex-column align-items-center justify-content-center">
        <div
          class="width-100 bg-guize white fs-big fw-bold textAlign-c"
          :style="{ height: (bodyWidth * 326 * 0.6) / 1296 + 'px', lineHeight: (bodyWidth * 326 * 0.6) / 1296 + 'px' }"
        >
          计算公式
        </div>
        <div class="width-100 padding-15 bg-white fs-mid textAlign-c">
          {{ formula_text }}
        </div>
      </div>
      <van-icon name="close" color="#fff" class="margin-ts" size="24px" @click="showGuiZe = false" />
    </van-overlay>
    <van-overlay :show="show" class="flex-column align-items-center justify-content-end">
      <!-- <van-picker
        title="选择月份"
        show-toolbar
        :default-index="month2 - 1"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="show = false"
        class="width-100"
        style="z-index: 9999"
      /> -->
      <van-datetime-picker
        @confirm="onConfirm"
        @cancel="show = false"
        class="width-100"
        style="z-index: 9999"
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
      />
    </van-overlay>
    <Tabbar active="3" />
  </div>
</template>

<script>
import Tabbar from '../components/tabbar.vue';
import { getDepartmentRankingLists, getZhenjieRankingLists, getMemberRankingLists } from '../api/leaderboard.js';
export default {
  data() {
    return {
      currentDate: '',
      show: false,
      active: 0,
      loading: false,
      minDate: new Date(2023, 0, 1),
      maxDate: new Date(),
      finished: true,
      year: 0,
      month: '2023-08-01',
      month2: 1,
      list: [],
      dept_info: { id: null, name: '', score: '0', ranking_num: '0' },
      columns: [
        { text: '1月', value: 1 },
        { text: '2月', value: 2 },
        { text: '3月', value: 3 },
        { text: '4月', value: 4 },
        { text: '5月', value: 5 },
        { text: '6月', value: 6 },
        { text: '7月', value: 7 },
        { text: '8月', value: 8 },
        { text: '9月', value: 9 },
        { text: '10月', value: 10 },
        { text: '11月', value: 11 },
        { text: '12月', value: 12 }
      ],
      formula_text: '',
      showGuiZe: false,
      bodyWidth: ''
    };
  },
  components: {
    Tabbar
  },
  beforeMount() {
    this.$nextTick(() => {
      this.bodyWidth = document.body.clientWidth;
    });
    console.log(this.$store.state.userInfo, 'userInfos', this.$store.state.userInfo.dept_id == 0);
    if (this.$store.state.userInfo.dept_id == 0) {
      this.active = 2;
    }
    let date = new Date();
    this.year = date.getFullYear();
    this.month2 = date.getMonth() + 1;
    this.month = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.getList();
  },
  methods: {
    // 显示积分计算规则
    showRule() {
      this.showGuiZe = true;
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val * 1}月`;
      }
      return val * 1;
    },
    onLoad() {
      const _this = this;
      setTimeout(() => {
        console.log(12);
        _this.loading = false;
      }, 2000);
    },
    onConfirm(key) {
      let date = new Date(key);
      this.month2 = date.getMonth() + 1;
      this.year = date.getFullYear();
      this.month = date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1) + '-' + date.getDate();
      this.getList();
      this.show = false;
    },
    async getList() {
      this.loading = true;
      this.list = [];
      if (this.active == 0) {
        await getDepartmentRankingLists({ month: this.month })
          .then((res) => {
            if (res.code == 0) {
              this.list = res.data.lists;
              this.dept_info = res.data.info;
              this.formula_text = res.data.formula_text;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.active == 1) {
        await getZhenjieRankingLists({ month: this.month })
          .then((res) => {
            if (res.code == 0) {
              this.list = res.data.lists;
              this.dept_info = res.data.info;
              this.formula_text = res.data.formula_text;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.active == 2) {
        await getMemberRankingLists({ month: this.month })
          .then((res) => {
            if (res.code == 0) {
              this.list = res.data.lists;
              this.dept_info = res.data.info;
              this.formula_text = res.data.formula_text;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.bg-image {
  background-image: url('../assets/image/leaderboard/bg.png');
  background-size: 100%;
  background-repeat: no-repeat;
}

.bg-title {
  background-image: url('../assets/image/leaderboard/bg1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 4rem;
  position: relative;
}

.bg-date {
  height: 25px;
  width: 25px;
  background-image: url('../assets/image/leaderboard/calendar.png');
  background-size: 100% 100%;
}

.active-tag {
  color: white;
  background: #1e67f7;
  border-radius: 1.25rem;
  font-size: 14px;
  height: 28px;
  line-height: 28px;
}

.normal-tag {
  color: #1e67f7;
  font-size: 14px;
  height: 28px;
  line-height: 28px;
}

.bg-ranking {
  position: absolute;
  right: 10%;
  top: 0;
  background-image: url('../assets/image/leaderboard/rank.png');
  background-size: 100% 100%;
  width: 50px;
  height: 50px;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

::v-deep .van-overlay {
  z-index: 1000 !important;
}
.bg-guize {
  background-image: url('../assets/image/leaderboard/showGuiZe.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
